import React from "react";
import { makeStyles } from "@material-ui/core";

/**
 * Buyer-facing support card for the /pay checkout.
 */

// The server always populates both fields, so these only cover a missing payload.
const FALLBACK_PHONE = "+91 8064124248";
const FALLBACK_EMAIL = "shop@aisensy.com";

// wa.me takes digits only. A bare 10-digit affiliate number is Indian, matching
// this checkout's +91 default; anything longer already carries its dial code.
const waHref = (phone) => {
  const digits = String(phone || "").replace(/\D/g, "");
  if (!digits) return null;
  return `https://wa.me/${digits.length === 10 ? `91${digits}` : digits}`;
};

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(2),
    padding: "14px 16px",
    backgroundColor: "#ffffff",
    border: "1px solid #e5e7eb",
    borderRadius: 10,
    fontFamily: "'Inter', 'Roboto', sans-serif",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 8,
  },
  heading: {
    fontSize: 12,
    fontWeight: 600,
    letterSpacing: 0.4,
    textTransform: "uppercase",
    color: "#6b7280",
  },
  links: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "center",
    gap: 14,
  },
  link: {
    display: "inline-flex",
    alignItems: "center",
    gap: 4,
    textDecoration: "none",
    fontSize: 13,
    lineHeight: "18px",
    "&:hover $linkValue": { textDecoration: "underline" },
  },
  linkLabel: {
    color: "#374151",
    fontWeight: 500,
  },
  linkDash: {
    color: "#9ca3af",
  },
  linkValue: {
    color: "#04cf66",
    fontWeight: 600,
  },
  divider: {
    width: 4,
    height: 4,
    borderRadius: "50%",
    backgroundColor: "#d1d5db",
  },
}));

const SupportCard = ({ affiliate }) => {
  const classes = useStyles();

  const phone = ((affiliate && affiliate.supportPhone) || FALLBACK_PHONE).trim();
  const email = ((affiliate && affiliate.supportEmail) || FALLBACK_EMAIL).trim();
  const whatsapp = waHref(phone);

  if (!whatsapp && !email) return null;

  return (
    <div className={classes.root}>
      <div className={classes.heading}>Need help?</div>
      <div className={classes.links}>
        {whatsapp && (
          <a
            className={classes.link}
            href={whatsapp}
            target="_blank"
            rel="noreferrer noopener"
          >
            <span className={classes.linkLabel}>WhatsApp</span>
            <span className={classes.linkDash}>:</span>
            <span className={classes.linkValue}>{phone}</span>
          </a>
        )}
        {whatsapp && email && (
          <span className={classes.divider} aria-hidden="true" />
        )}
        {email && (
          <a className={classes.link} href={`mailto:${email}`}>
            <span className={classes.linkLabel}>Email</span>
            <span className={classes.linkDash}>:</span>
            <span className={classes.linkValue}>{email}</span>
          </a>
        )}
      </div>
    </div>
  );
};

export default SupportCard;
